import { render, staticRenderFns } from "./MenusCategory.vue?vue&type=template&id=1633b1e2&"
import script from "./MenusCategory.vue?vue&type=script&lang=js&"
export * from "./MenusCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports